import { useTeams } from "@/contexts/teams-provider";

type NewNavigationReturn = {
  isNewNavigationEnabled: boolean;
};

/**
 * Single read point for the team-level chat-first navigation flag.
 *
 * Strict `=== true` on purpose: a team still loading, a payload served from an
 * older cache, or a team the API answered without the field must all fall back
 * to the navigation users already know. Turning the prospecting module off is
 * the deliberate case, never the default one.
 */
export function useNewNavigation(): NewNavigationReturn {
  const { teamSelected } = useTeams();

  return {
    isNewNavigationEnabled: teamSelected?.featureNewNavigationEnabled === true,
  };
}
